export const VISUALLY_HIDDEN = {
  position: "absolute" as const,
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden" as const,
  clipPath: "inset(50%)",
  whiteSpace: "nowrap" as const,
  border: 0,
};

export default VISUALLY_HIDDEN;
